import $ from "jquery";

class Mobile {

    constructor() {
        this.bindMenu();
        this.bindFilters();
        this.bindSidebar();
    }

    bindMenu() {
        $(document).ready(() => {

            $('.menu__mobile .menu__item--arrow').on('click', (event) => {
                $('.menu__mobile .menu__list .menu__item > .categories > .categories__list').slideToggle();
                $(event.currentTarget).toggleClass('active');
            });

            $('.menu__mobile .categories__item-open').on('click', (event) => {
                event.stopPropagation();
                event.preventDefault();

                $(event.currentTarget).parent().find('.categories__item-sub').eq(0).slideToggle();

                $(event.currentTarget).toggleClass('active');
            });

        });
    }

    bindFilters() {
        $(document).ready(() => {

            $('.filters__bar a').on('click', (event) => {
               const element = $(event.currentTarget);
               const filters = $('.products__filters');

               if (filters.hasClass('products__filters--hidden')) {
                   filters.removeClass('products__filters--hidden');
                   element.text(element.data('text-close'));
               } else {
                   filters.addClass('products__filters--hidden');
                   element.text(element.data('text-show'));
               }
            });

        });
    }

    bindSidebar() {
        $(document).ready(() => {

            $('.sidebar__bar a').on('click', (event) => {
                const element = $(event.currentTarget);
                const sidebar = $('.sidebar');

                if (sidebar.hasClass('sidebar--hidden')) {
                    sidebar.removeClass('sidebar--hidden');
                    element.text(element.data('text-close'));
                } else {
                    sidebar.addClass('sidebar--hidden');
                    element.text(element.data('text-show'));
                }
            });

        });
    }

}

export default new Mobile();
